import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type SidebarMenuProps = ComponentProps<'ul'>;

const SidebarMenu = ({ className, ...props }: SidebarMenuProps) => {
  return (
    <ul
      data-slot="sidebar-menu"
      data-sidebar="menu"
      className={cn('flex w-full min-w-0 flex-col gap-0', className)}
      {...props}
    />
  );
};

export default SidebarMenu;
